import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { BRAND, CONTACT, NAV_ITEMS } from "@/data/content";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src={BRAND.logo} alt={BRAND.name} className="h-11 w-11 object-contain" />
              <span className="font-heading font-bold text-xl text-white">
                Impulsion<span className="text-green-500"> Locale</span>
              </span>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed">
              {BRAND.slogan} Nous aidons les commerces et artisans de proximité à attirer
              plus de clients grâce à une visibilité en ligne simple et efficace.
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-slate-400">
              <MapPin size={16} className="text-green-500" /> {CONTACT.zoneText}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3 text-sm">
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="hover:text-green-500 transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 hover:text-green-500 transition-colors">
                  <Phone size={16} className="text-green-500" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-green-500 transition-colors">
                  <MessageCircle size={16} className="text-green-500" /> WhatsApp
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-green-500 transition-colors break-all">
                  <Mail size={16} className="text-green-500" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {BRAND.name}. Tous droits réservés.</p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="hover:text-green-500 transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-green-500 transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
